module.exports = __webpack_public_path__ + "static/fonts/weathericons-regular-webfont.e7ef2b4.eot";


//////////////////
// WEBPACK FOOTER
// ./~/weather-icons/font/weathericons-regular-webfont.eot
// module id = 309
// module chunks = 1